import { FC } from 'react';

import { getPopupContentStyle } from './ColumnPickerPopup.styled';
import ColumnPickerSettings from './components/ColumnPickerSettings/ColumnPickerSettings';
import { columns } from './components/ColumnPickerSettings/mockedColumns';
import useColumnPickerSettingsPopup from './hooks/useColumPickerSettingsPopup';
import Popup from 'components/Popup/Popup';
import { useResponsive } from 'contexts/ResponsiveContext';
import { ScrollLockIdE } from 'declarations/enums/scroll';
import { NoopT } from 'declarations/types/common';

type ColumnPickerSettingsPopupPropsT = {
  isOpen?: boolean;
  onClose?: NoopT;
};

const ColumnPickerSettingsPopup: FC<ColumnPickerSettingsPopupPropsT> = ({ isOpen, onClose }) => {
  /**
   * Hooks
   */
  const { handleCloseColumnPickerPopup, isPopupOpened } = useColumnPickerSettingsPopup();

  const { isMobile } = useResponsive();

  return (
    <Popup
      showCloseBtn
      popupId={ScrollLockIdE.OpenNewTicketPopup}
      contentStyle={getPopupContentStyle(isMobile)}
      isOpen={isPopupOpened || isOpen}
      onClose={handleCloseColumnPickerPopup(onClose)}
      closeOnEscape={false}
      closeOnDocumentClick={false}
      data-testid="column-picker-popup"
    >
      <ColumnPickerSettings columns={columns} />
    </Popup>
  );
};

export default ColumnPickerSettingsPopup;
